<template>
  <div>
    申请代理
  </div>
</template>

<script>
export default {
components: {},
  data() {
    return {
      
    };
  },
created() {},
computed: {},
methods: {},
};
</script>

<style scoped lang='scss'>

</style>